import React, { useState } from 'react';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepLocation from './StepLocation';
import StepThree from './StepThree';

const AccountSetup: React.FC = () => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const handleNext = () => setCurrentStep((s) => Math.min(s + 1, 4));
  const handleBack = () => setCurrentStep((s) => Math.max(1, s - 1));

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <StepOne onNext={handleNext} />;
      case 2:
        return <StepTwo onBack={handleBack} onNext={handleNext} />;
      case 3:
        return <StepThree onBack={handleBack} onNext={handleNext} />;
      case 4:
        return <StepLocation onBack={handleBack} />;
      default:
        return null;
    }
  };

  return <div>{renderStep()}</div>;
};

export default AccountSetup;